/* Lily & Ruby — cart tier bar (10% / 15% / 20%) */
(function () {
  var tiers = [{ q: 2, p: 10 }, { q: 3, p: 15 }, { q: 4, p: 20 }];

  function fillFor(count) {
    if (count <= 0) return 0;
    if (count < 2) return (count / 2) * 33.33;
    return Math.min(100, (count - 1) * 33.33);
  }

  function render(count) {
    var next = null, cur = null, i;
    for (i = 0; i < tiers.length; i++) { if (count < tiers[i].q) { next = tiers[i]; break; } }
    for (i = tiers.length - 1; i >= 0; i--) { if (count >= tiers[i].q) { cur = tiers[i]; break; } }
    var msg;
    if (!next) {
      msg = '<strong>20% off unlocked</strong> · applied at checkout';
    } else {
      var n = next.q - count;
      msg = 'Add <strong>' + n + ' more item' + (n > 1 ? 's' : '') + '</strong> for <strong>' + next.p + '% off</strong>';
      if (cur) msg = '<strong>' + cur.p + '% off unlocked</strong> · ' + msg;
    }
    document.querySelectorAll('[data-lr-cartbar]').forEach(function (el) {
      var m = el.querySelector('.lr-cartbar__msg');
      var f = el.querySelector('.lr-cartbar__fill');
      if (m) m.innerHTML = msg;
      if (f) f.style.width = fillFor(count) + '%';
      el.querySelectorAll('[data-tier]').forEach(function (s) {
        s.classList.toggle('is-done', count >= parseInt(s.getAttribute('data-tier'), 10));
      });
    });
  }

  var pending;
  function refresh() {
    clearTimeout(pending);
    pending = setTimeout(function () {
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { render(c.item_count || 0); })
        .catch(function () {});
    }, 120);
  }

  function isCartUrl(u) {
    u = String(u || '');
    return /\/cart\/(add|change|update|clear)/.test(u);
  }

  if (window.fetch) {
    var of = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url);
      var p = of.apply(this, arguments);
      if (isCartUrl(url)) p.then(refresh, refresh);
      return p;
    };
  }
  var oo = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (isCartUrl(url)) this.addEventListener('loadend', refresh);
    return oo.apply(this, arguments);
  };

  document.addEventListener('DOMContentLoaded', refresh);
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.js-drawer-open-cart, [href="/cart"]')) refresh();
  });
})();
